import CorporateBurn from '../components/CorporateBurn'
import CorporateRProgram from '../components/CorporateRProgram'
import FAQ from '../components/FAQ'
import FormSection from '../components/FormSection'
import HeroSectionBox from '../components/HeroSectionBox'
import HowItWorks from '../components/HowItWorks'
import OurTeam from '../components/OurTeam'
import ReviewSection from '../components/ReviewSection'
import './Home.css'
export default function Home() {
  return (
    <div className='crp-home'>
        <HeroSectionBox/>
        <CorporateBurn/>
        <CorporateRProgram/>
        <HowItWorks/>
        <OurTeam/>
        <ReviewSection/>
        <FAQ/>
        <FormSection/>
    </div>
  )
}
